import React from 'react';
import PropTypes from 'prop-types';
import { withStyles, withTheme } from '@material-ui/core/styles';
import BaseListSlick, { styles } from '../../front/Shared/ListSlick';
import Card from '../Businesses/Card';

class ListSlick extends BaseListSlick {
  slickItemsRenderer(): * {
    const {
      classes,
      businesses = [],
      isAuthenticated,
      disableTurbolinks,
      // デフォルトでは、フォローボタンを表示する
      isShowFollowButton = true,
    } = this.props;
    return businesses.map((business, index) => (
      <Card
        key={`business-list-slick${index}`}
        className={classes.card}
        isAuthenticated={isAuthenticated}
        isShowFollowButton={isShowFollowButton}
        disableTurbolinks={disableTurbolinks}
        {...business}
      />
    ));
  }
}

ListSlick.propTypes = {
  businesses: PropTypes.arrayOf(PropTypes.shape(Card.propTypes)),
  isAuthenticated: PropTypes.bool,
  disableTurbolinks: PropTypes.bool,
};

export default withTheme(withStyles(styles)(ListSlick));
